var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{staticClass:"create-production h-full"},[_c('PanelWithMaterialPurchaseOrderEditor')],1)}
var staticRenderFns = []

export { render, staticRenderFns }